import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Google Analytics tracking hook
export const useAnalytics = () => {
  const location = useLocation();

  // Track page views
  useEffect(() => {
    if (window.gtag) {
      window.gtag('config', 'G-5JJFP9ZXKR', {
        page_path: location.pathname + location.search
      });
    }
  }, [location]);

  // Track custom events
  const trackEvent = (action, category, label, value) => {
    if (window.gtag) {
      window.gtag('event', action, {
        event_category: category,
        event_label: label,
        value: value
      });
    }
  };

  // Track form submissions
  const trackFormSubmission = (formName) => {
    trackEvent('form_submit', 'engagement', formName);
  };

  // Track button clicks
  const trackButtonClick = (buttonName, page) => {
    trackEvent('button_click', 'engagement', buttonName, page);
  };

  // Track app page visits
  const trackAppVisit = (appName) => {
    trackEvent('app_visit', 'engagement', appName);
  };

  // Track external link clicks
  const trackExternalLink = (linkName, destination) => {
    trackEvent('external_link_click', 'engagement', linkName, destination);
  };

  return {
    trackEvent,
    trackFormSubmission,
    trackButtonClick,
    trackAppVisit,
    trackExternalLink
  };
};
